var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('v-checkbox',{attrs:{"label":_vm.field.name},model:{value:(_vm.enableWalkin),callback:function ($$v) {_vm.enableWalkin=$$v},expression:"enableWalkin"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }